<template>
  <div class="product">
    <header class="page-header" data-aos="fade-up">
      <div class="container">
        <div class="heading-text" v-html="$t('farmsProducts.headerTopText')" data-aos="fade-up"></div>
        <p data-aos="fade-up" data-aos-delay="100">{{$t('farmsProducts.headerTopSubText')}}</p>
        <span class="line" data-aos="zoom-in-left" data-aos-delay="150"></span>
        <p v-html="$t('farmsProducts.headerText')" data-aos="fade-up" data-aos-delay="200"></p>
        <div class="btn-hover">
          <router-link to="/products/farms/presentation" class="btn orange" data-aos="fade-up" data-aos-delay="250">
            {{$t('component.watchPresentation')}}<span/></router-link>
        </div>
        <div
          class="btn-hover"
          @click="openVideoModal('presentation')"
        >
          <div class="btn orange" data-aos="fade-up" data-aos-delay="250">{{$t('component.watchVideo')}}<span/></div>
        </div>
         <div
          class="btn-hover"
          @click="openVideoModal('realExample')"
        >
          <div class="btn orange" data-aos="fade-up" data-aos-delay="250">{{$t('component.watchExampleVideo')}}<span/></div>
        </div>
        <div class="dropdown" @mouseover="showDropdown" @mouseleave="hideDropdown" data-aos="fade-up" data-aos-delay="250">
          <div class="dropdown-btn orange" >
            {{$t('component.watchBooklet')}}<span/>
          <div v-if="isDropdownVisible" class="dropdown-menu">
          <ul>
            <li v-for="booklet in booklets" :key="booklet.language" @click="downloadBooklet(booklet.language)">
                {{$t(booklet.translationKey)}}
                <i class="material-icons">download</i>
              </li>
          </ul>
        </div>
      </div>
      </div>
      </div>
      <a @click="smoothScroll" data-scroll-offset="120" href="#top" class="more-about-us white" data-aos="fade-up"
         data-aos-delay="300"><span>{{$t('component.moreAboutUs')}}</span></a>
    </header>

    <div id="top" class="why-us-solution">
      <div class="top-text">
        <p v-html="$t('farmsProducts.whyOurSolutionText')" data-aos="fade-up"></p>
        <h2 data-aos="fade-up">{{$t('farmsProducts.whyOurSolution')}}</h2>
      </div>
      <div class="elements">
        <div class="element right clearfix">
          <div class="image">
            <figure class="hexagon-image resizable" style="background-image: url('/static/img/product/image1.jpg')"
                    data-aos="fade-up">
              <div class="hexTop"></div>
              <div class="hexBottom"></div>
            </figure>
            <div class="line" data-aos="zoom-in-right" data-aos-delay="150"></div>
          </div>
          <div class="text-box">
            <div class="heading" data-aos="fade-up">
              <div class="hexagon" data-aos="flip-right" data-aos-delay="100"><span>1</span></div>
              <span class="text" data-aos="fade-up">{{$t('farmsProducts.sectionOneTitle')}}</span></div>
            <ul>
              <li data-aos="fade-up" data-aos-delay="200">
                <span class="dot"></span><span class="text">{{$t('farmsProducts.sectionOneText1')}}</span>
              </li>
              <li data-aos="fade-up" data-aos-delay="250">
                <span class="dot"></span><span class="text">{{$t('farmsProducts.sectionOneText2')}}</span>
              </li>
              <li data-aos="fade-up" data-aos-delay="300">
                <span class="dot"></span><span class="text">{{$t('farmsProducts.sectionOneText3')}}</span>
              </li>
              <li data-aos="fade-up" data-aos-delay="350">
                <span class="dot"></span><span class="text">{{$t('farmsProducts.sectionOneText4')}}</span>
              </li>
              <li data-aos="fade-up" data-aos-delay="400">
                <span class="dot"></span><span class="text">{{$t('farmsProducts.sectionOneText5')}}</span>
              </li>
            </ul>
          </div>
        </div>
        <div class="element left clearfix">
          <div class="image">
            <figure class="hexagon-image resizable" style="background-image: url('/static/img/product/image2.jpg')"
                    data-aos="fade-up">
              <div class="hexTop"></div>
              <div class="hexBottom"></div>
            </figure>
            <div class="line" data-aos="zoom-in-left" data-aos-delay="150"></div>
          </div>
          <div class="text-box">
            <div class="heading" data-aos="fade-up">
              <div class="hexagon" data-aos="flip-left" data-aos-delay="100"><span>2</span></div>
              <span class="text" data-aos="fade-up">{{$t('farmsProducts.sectionTwoTitle')}}</span></div>
            <ul>
              <li data-aos="fade-up" data-aos-delay="200">
                <span class="dot"></span><span class="text" v-html="$t('farmsProducts.sectionTwoText1')"></span>
              </li>
              <li data-aos="fade-up" data-aos-delay="250">
                <strong>{{$t('farmsProducts.sectionTwoText2')}}</strong>
              </li>
              <li data-aos="fade-up" data-aos-delay="300">
                <span class="dot"></span><span class="text">{{$t('farmsProducts.sectionTwoText3')}}</span>
              </li>
              <li data-aos="fade-up" data-aos-delay="350">
                <span class="dot"></span><span class="text">{{$t('farmsProducts.sectionTwoText4')}}</span>
              </li>
            </ul>
          </div>
        </div>
        <div class="element right clearfix">
          <div class="image">
            <figure class="hexagon-image resizable" style="background-image: url('/static/img/product/image3.jpg')"
                    data-aos="fade-up">
              <div class="hexTop"></div>
              <div class="hexBottom"></div>
            </figure>
            <div class="line"></div>
          </div>
          <div class="text-box">
            <div class="heading" data-aos="fade-up">
              <div class="hexagon" data-aos="flip-right" data-aos-delay="100"><span>3</span></div>
              <span class="text" data-aos="fade-up">{{$t('farmsProducts.sectionThreeTitle')}}</span></div>
            <ul>
              <li data-aos="fade-up" data-aos-delay="200">
                <span class="dot"></span><span class="text">{{$t('farmsProducts.sectionThreeText1')}}</span>
              </li>
              <li data-aos="fade-up" data-aos-delay="250">
                <span class="dot"></span><span class="text">{{$t('farmsProducts.sectionThreeText2')}}</span>
              </li>
              <li data-aos="fade-up" data-aos-delay="300">
                <span class="dot"></span><span class="text">{{$t('farmsProducts.sectionThreeText3')}}</span>
              </li>
              <li data-aos="fade-up" data-aos-delay="350">
                <span class="dot"></span><span class="text">{{$t('farmsProducts.sectionThreeText4')}}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom-first orange-bg">

      <div class="image-boxes inline-boxes">
        <div class="container">
          <div class="box" data-aos="fade-up" data-aos-delay="100">
            <img src="/static/img/product/image-box-1.jpg" alt="team1">
          </div>
          <div class="box" data-aos="fade-up" data-aos-delay="150">
            <img src="/static/img/product/image-box-2.jpg" alt="team2">
          </div>
          <div class="box" data-aos="fade-up" data-aos-delay="200">
            <img src="/static/img/product/image-box-3.jpg" alt="team3">
          </div>
          <div class="box" data-aos="fade-up" data-aos-delay="250">
            <img src="/static/img/product/image-box-4.jpg" alt="team4">
          </div>
        </div>
      </div>
    </div>
    <div class="bottom-last">
      <div class="content">
        <h2 data-aos="fade-up">{{$t('farmsProducts.whyIShouldUseThis')}}</h2>
        <div class="elements">
          <div class="element">
            <Counter :data="circleValues[0]"></Counter>
            <div class="bottom" data-aos="fade-up" data-aos-delay="150">
              <p>{{$t('farmsProducts.whyIShouldUseThisOneText')}}</p>
            </div>
          </div>
          <div class="element">
            <Counter :data="circleValues[1]"></Counter>
            <div class="bottom" data-aos="fade-up" data-aos-delay="250">
              <p>{{$t('farmsProducts.whyIShouldUseThisTwoText')}}</p>
            </div>
          </div>
          <div class="element">
            <Counter :data="circleValues[2]"></Counter>
            <div class="bottom" data-aos="fade-up" data-aos-delay="350">
              <p>{{$t('farmsProducts.whyIShouldUseThisThreeText')}}</p>
            </div>
          </div>
          <div class="element">
            <Counter :data="circleValues[3]"></Counter>
            <div class="bottom" data-aos="fade-up" data-aos-delay="450">
              <p>{{$t('farmsProducts.whyIShouldUseThisFourText')}}</p>
            </div>
          </div>
        </div>
        <div class="btn-hover">
          <router-link to="/products/farms/presentation" class="btn orange" data-aos="fade-up">
            {{$t('component.watchPresentation')}}<span/></router-link>
        </div>
      </div>
    </div>
    <footer-more-information :modalpage="'farms'"/>
    <footer-main/>
  </div>
</template>

<script>
  import store from '../store/store';
  import FooterMain from '../components/FooterMain';
  import FooterMoreInformation from '../components/FooterMoreInformation';
  import VideoBox from '../components/VideoBox';
  import Counter from '../components/Counter';
  import smoothScroll from '../helpers/SmoothScroll';

  export default {
    name: 'farms-product',
    components: {
      FooterMain,
      FooterMoreInformation,
      VideoBox,
      Counter
    },
    data: function () {
      return {
        isDropdownVisible: false,
        booklets: [
          { language: 'EN', translationKey: 'component.bookletEnglish' },
          { language: 'DT', translationKey: 'component.bookletDeutch' },
          { language: 'FR', translationKey: 'component.bookletFrench' },
          { language: 'JP', translationKey: 'component.bookletJapanese' },
          { language: 'PL', translationKey: 'component.bookletPolish' }
        ],
        circleValues: [
          {
            before: this.$t('farmsProducts.whyIShouldUseThisOneTopBefore'),
            val: this.$t('farmsProducts.whyIShouldUseThisOneTop'),
            after: this.$t('farmsProducts.whyIShouldUseThisOneTopAfter'),
          },
          {
            before: this.$t('farmsProducts.whyIShouldUseThisTwoTopBefore'),
            val: this.$t('farmsProducts.whyIShouldUseThisTwoTop'),
            after: this.$t('farmsProducts.whyIShouldUseThisTwoTopAfter'),
          },
          {
            before: this.$t('farmsProducts.whyIShouldUseThisThreeTopBefore'),
            val: this.$t('farmsProducts.whyIShouldUseThisThreeTop'),
            after: this.$t('farmsProducts.whyIShouldUseThisThreeTopAfter'),
          },
          {
            before: this.$t('farmsProducts.whyIShouldUseThisFourTopBefore'),
            val: this.$t('farmsProducts.whyIShouldUseThisFourTop'),
            after: this.$t('farmsProducts.whyIShouldUseThisFourTopAfter'),
          },
        ]

      }
    },
    computed: {
      lang: () => {
        return store.state.lang;
      },
      smoothScroll: () => smoothScroll
    },
    methods: {
      showDropdown() {
        this.isDropdownVisible = true;
      },
      hideDropdown() {
        this.isDropdownVisible = false;
      },
      downloadBooklet(language) {
        const link = document.createElement('a');
        link.href = `/static/booklet/Bioseco_booklet_${language}.pdf`;
        link.download = `Bioseco_Booklet_${language}.pdf`; 
        link.click();
      },
     openVideoModal(type) {
       this.$store.commit('SET_MODAL_STATIC_VIDEO_TYPE', type);
       this.$modal.show('video-static');
      }
    },
      }
</script>



// WEBPACK FOOTER //
// FarmsProduct.vue?06cdbbd8